// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import {
    getEventsContacts as listEventsContactsAPI,
    getEventsContact as getEventsContactAPI,
    addEventsContact as addEventsContactAPI,
    updateEventsContact as updateEventsContactAPI,
    deleteEventsContact as deleteEventsContactAPI,
} from '../../helpers/';

import { eventsContactsApiResponseError, eventsContactsApiResponseSuccess } from './actions';
import { EventsContactsActionTypes } from './constants';

function* getEventsContact({ payload: { id } }) {
    try {
        const response = yield call(getEventsContactAPI, id );
        const eventoContactoItem = response.data.data;
        yield put(eventsContactsApiResponseSuccess(EventsContactsActionTypes.GET_EVENTS_CONTACTS, eventoContactoItem));
    } catch (error) {
        yield put(eventsContactsApiResponseError(EventsContactsActionTypes.GET_EVENTS_CONTACTS, error));
    }
}

function* addEventsContact({payload:eventoContacto}){
    try{
        const response = yield call(addEventsContactAPI,{...eventoContacto})
        const eventoContactoItem = response.data
        yield put(eventsContactsApiResponseSuccess(EventsContactsActionTypes.ADD_EVENTS_CONTACTS,eventoContactoItem))
    } catch(error){
        yield put(eventsContactsApiResponseError(EventsContactsActionTypes.ADD_EVENTS_CONTACTS,error))
    }
}

function* updateEventsContact({payload:eventoContacto}){
    try{
        const response = yield call(updateEventsContactAPI,{...eventoContacto})
        const eventoContactoItem = response.data.data
        yield put(eventsContactsApiResponseSuccess(EventsContactsActionTypes.UPDATE_EVENTS_CONTACTS,eventoContactoItem))
    }catch(error){
        yield put(eventsContactsApiResponseError(EventsContactsActionTypes.UPDATE_EVENTS_CONTACTS,error))
    }
}
function* deleteEventsContact({payload:{id}}){
    try{
        const response = yield call(deleteEventsContactAPI,id)
        const eventoContactoItem = response.data.id
        yield put(eventsContactsApiResponseSuccess(EventsContactsActionTypes.DELETE_EVENTS_CONTACTS,eventoContactoItem))
    }catch(error){
        yield put(eventsContactsApiResponseError(EventsContactsActionTypes.DELETE_EVENTS_CONTACTS,error))
    }
}

/**
 * List contactos
 */
function* listEventsContacts({payload:params}) {
    try {
        const response = yield call(listEventsContactsAPI, { ...params });
        const listaEventosContactos = response.data.data;
        yield put(eventsContactsApiResponseSuccess(EventsContactsActionTypes.LIST_EVENTS_CONTACTS, listaEventosContactos));
    } catch (error) {
        yield put(eventsContactsApiResponseError(EventsContactsActionTypes.LIST_EVENTS_CONTACTS, error));
    }
}


export function* watchGetEventsContact(): any {
    yield takeEvery(EventsContactsActionTypes.GET_EVENTS_CONTACTS, getEventsContact);
}

export function* watchListEventsContacts(): any {
    yield takeEvery(EventsContactsActionTypes.LIST_EVENTS_CONTACTS, listEventsContacts);
}

export function* watchAddEventsContact():any{
    yield takeEvery(EventsContactsActionTypes.ADD_EVENTS_CONTACTS, addEventsContact)
}
export function* watchUpdateEventsContact():any{
    yield takeEvery(EventsContactsActionTypes.UPDATE_EVENTS_CONTACTS, updateEventsContact)
}
export function* watchDeleteEventsContact():any{
    yield takeEvery(EventsContactsActionTypes.DELETE_EVENTS_CONTACTS, deleteEventsContact)
}


function* eventsContactsSaga(): any {
    yield all([
        fork(watchGetEventsContact),
        fork(watchListEventsContacts),
        fork(watchAddEventsContact),
        fork(watchUpdateEventsContact),
        fork(watchDeleteEventsContact),
    ]);
}

export default eventsContactsSaga;
